import {
  withTranslation,
} from 'react-i18next';

import InputResultView from './InputResultView';

const TranslatedComponent = withTranslation()(InputResultView);

const Component = TranslatedComponent;

export default Component;
